export const ResponseStatus = {
    UNAUTHORIZED: 401,
    BAD_REQUEST:400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_ERROR: 500,
};